// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9t-3";
export var contentContainer = "_9t-0";
export var editorContainer = "_9t-1";
export var quillInputForm = "_9t-2";
export var zoneDivider = "_9t-4";